export default __webpack_public_path__ + "static/media/sponsor-times.d197112f.png";